module.exports = __webpack_public_path__ + "img/9788954427173.ff569a31.jpg";